export const LOGIN_SUCCESS = 'LOGIN/SUCCESS';
export const LOGIN_FALIURE = 'LOGIN/FALIURE';
export const LOGOUT_SUCCESS = 'LOGOUT/SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT/FAILURE';
export const AGREE_TERMS_SUCCESS = 'AGREE_TERMS/SUCCESS';
export const AGREE_TERMS_FAILURE = 'AGREE_TERMS/FAILURE';
export const FETCH_PRACTICE_SUCCESS = 'FETCH_PRACTICE/SUCCESS';
export const FETCH_PRACTICE_FAILURE = 'FETCH_PRACTICE/FAILURE';
export const FETCH_ORGANIZATION_SUCCESS = 'FETCH_ORGANIZATION/SUCCESS';
export const FETCH_ORGANIZATION_FAILURE = 'FETCH_ORGANIZATION/FAILURE';
export const UPDATE_PRACTICE_RBL_THRESHOLD = 'UPDATE_PRACTICE_RBL_THRESHOLD';
export const UPDATE_PRIMARY_PRACTICE = 'UPDATE_PRIMARY_PRACTICE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER/SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER/FAILURE';
export const UPDATE_CONFIDENCE_THRESHOLD = 'UPDATE_CONFIDENCE_THRESHOLD';
export const UPDATE_VIDEA_BEACON_CONNECTION_STATUS =
  'UPDATE_VIDEA_BEACON_CONNECTION_STATUS';
export const GET_USER_SUCCESS = 'GET_USER/SUCCESS';
export const GET_USER_FAILURE = 'GET_USER/FAILURE';
export const CLEAR_PRACTICE = 'CLEAR_PRACTICE';

export const CONNECTED = 'CONNECTED';
export const CONNECTING = 'CONNECTING';
export const DISCONNECTED = 'DISCONNECTED';
export const ERROR = 'ERROR';

export const RESET = 'RESET';
export const UPDATE_ASSIST_SETTINGS = 'UPDATE_ASSIST_SETTINGS';
